import { z } from 'zod/v4';

export enum StepEnum {
    required = 'required',
    optional = 'optional',
    dontShow = 'dont_show',
}

export const StepEnumRuntype = z.enum(StepEnum);

const ColumnSettingsRuntype = z
    .object({
        hidden: z.boolean().nullable().optional(),
    })
    .optional();
export type SupplierPortalColumnSettings = z.infer<typeof ColumnSettingsRuntype>;

export const AllColumnSettingsRuntype = z.object({
    bid: ColumnSettingsRuntype,
    ipn: ColumnSettingsRuntype,
    cancellationWindow: ColumnSettingsRuntype,
    cancellationWindowUnit: ColumnSettingsRuntype,
    itemClass: ColumnSettingsRuntype,
    leadTimeDays: ColumnSettingsRuntype,
    moq: ColumnSettingsRuntype,
    mpq: ColumnSettingsRuntype,
    ncnr: ColumnSettingsRuntype,
    notes: ColumnSettingsRuntype,
    oneTimeCosts: ColumnSettingsRuntype,
    packaging: ColumnSettingsRuntype,
    potentialQuantity: ColumnSettingsRuntype,
    pricePer: ColumnSettingsRuntype,
    quantity: ColumnSettingsRuntype,
    selected: ColumnSettingsRuntype,
    stdFactoryLeadTime: ColumnSettingsRuntype,
    stdFactoryLeadTimeUnit: ColumnSettingsRuntype,
    stock: ColumnSettingsRuntype,
    supplierPartNumber: ColumnSettingsRuntype,
    totalPrice: ColumnSettingsRuntype,
    unitPrice: ColumnSettingsRuntype,
    validFrom: ColumnSettingsRuntype,
    validUntil: ColumnSettingsRuntype,
});

export interface SupplierPortalSettingsDTO extends z.infer<typeof SupplierPortalSettingsRuntype> {}
export const SupplierPortalSettingsRuntype = z.object({
    default_days_before_offer_invalid: z.number().nullable(),
    show_supplier_portal_link: z.boolean(),
    upload_additional_supplier_files: StepEnumRuntype,
    hours_until_frozen: z.number().nullable().optional(),
    should_include_pcb_specification: z.boolean().optional(),
    should_include_shipping_panel_specification: z.boolean().optional(),
    quote_columns: AllColumnSettingsRuntype.optional(),
    custom_part_quote_columns: AllColumnSettingsRuntype.optional(),
});

export interface PatchSupplierPortalSettingsDTO extends z.infer<typeof PatchSupplierPortalSettingsRuntype> {}
export const PatchSupplierPortalSettingsRuntype = z.object({
    default_days_before_offer_invalid: z.number().nullable().optional(),
    show_supplier_portal_link: z.boolean().optional(),
    upload_additional_supplier_files: StepEnumRuntype.optional(),
    hours_until_frozen: z.number().nullable().optional(),
    should_include_pcb_specification: z.boolean().optional(),
    should_include_shipping_panel_specification: z.boolean().optional(),
    quote_columns: AllColumnSettingsRuntype.optional(),
    custom_part_quote_columns: AllColumnSettingsRuntype.optional(),
});
